<template>
  <div>
    <!-- date header ~*~~*~~*~~*~~*~~*~~*~~*~ -->
    <v-card dark flat color="primary" class="align-start">
      <v-container>
        <v-layout align-center>
          <span class="display-4 font-weight-regular mr-4">
            {{ today.date }}
          </span>
          <v-layout column>
            <div class="display-1 text-left pb-2">{{ title }}</div>
            <div class="headline text-left font-weight-light">
              {{ today.dayOfWeek }}
            </div>
            <div class="body-1  text-left text-uppercase font-weight-light">
              {{ today.month }} {{ today.year }}
            </div>
          </v-layout>
        </v-layout>
      </v-container>
    </v-card>
    <!-- no data ~*~~*~~*~~*~~*~~*~~*~~*~ -->
    <v-card v-if="points.length == 0" outlined flat>
      <v-card-text class="title">
        No data points.
      </v-card-text>
    </v-card>
    <!-- data points ~*~~*~~*~~*~~*~~*~~*~~*~ -->
    <v-card v-else outlined flat>
      <v-timeline dense color="white">
        <v-timeline-item
          v-for="(point, p) in points"
          :key="p"
          :color="point.color"
          small>
            <v-layout>
              <v-flex xs3>
                <div class="overline font-weight-medium text-left mt-1">
                  {{ point.time | fixTime }}
                </div>
              </v-flex>
              <v-flex>
                <span 
                  v-bind:style="{ color: point.color }"
                  class="body-2 text-uppercase font-weight-medium">
                  {{ point.title }}
                  </span>
                <span
                  v-if="point.description"
                  v-html="point.description"
                  class="caption"
                ></span>
              </v-flex>
            </v-layout>
        </v-timeline-item>
      </v-timeline>
   </v-card>  
  </div>
</template>
<script>
import moment from 'moment'
export default {
  filters: {
    fixTime(val) {
      if (val) {
        // go from A to B
        return moment(val, 'MM/DD HH:mm').format('HH:mm')
      }
    }
  },
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    points: {
      type: Array,
      required: true
    },
    calculated: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      today: {},
      env: process.env.VUE_APP_ENV
    }
  },
  created() {    
    var marker = moment()
    if(this.env != 'production') {
      if (this.calculated != null) {
        marker = moment(this.calculated)
      }
    }
    this.today.date = moment(marker).format('DD')
    this.today.dayOfWeek = moment(marker).format('dddd')
    this.today.month = moment(marker).format('MMMM')
    this.today.year = moment(marker).format('YYYY')
    // console.log("points", this.points)
  }
}
</script>
